module.exports = __webpack_public_path__ + "img/pulse-l.da66a163.png";